import React from 'react';
import { Handle, Position } from 'reactflow';

const BacklinkSourceNode = ({ data }) => {
  // ==========================================================
  // --- خط دیباگ اصلی اینجا اضافه شده است ---
  console.log("Data received by BacklinkSourceNode:", data);
  // ==========================================================
  
  const isReportage = data.type === 'reportage';

  return (
    <div className={`backlink-node-body ${isReportage ? 'reportage-node' : 'backlink-node'} ${data.statusClassName || ''}`}>
      <Handle type="source" position={Position.Right} />

      <div className="node-content">
        <div className="site-name-row">
          <div className="site-name">{data.site_name}</div>
          {data.status && (
            <span className={`node-status-badge ${data.statusClassName}`}>
              {data.status}
            </span>
          )}
        </div>
        <div className="keyword">
          <span>کلمه کلیدی:</span>
          <strong>{data.target_keyword || '-'}</strong>
        </div>
        
        {isReportage ? (
          <>
            <div className="price"><span>هزینه رپورتاژ:</span><strong>{(data.price1 || 0).toLocaleString()} ت</strong></div>
            <div className="price"><span>هزینه/کلمه:</span><strong>{(data.price2 || 0).toLocaleString()} ت</strong></div>
          </>
        ) : (
          <div className="price"><span>هزینه بک‌لینک:</span><strong>{(data.price1 || 0).toLocaleString()} ت</strong></div>
        )}

        {/* --- اطمینان از نمایش تاریخ‌ها --- */}
        {data.start_date && (
        <div className="node-dates">
    <span>
        {data.start_date}
        {data.end_date ? ` الی ${data.end_date}` : ''}
    </span>
</div>
        )}
      </div>
    </div>
  );
};

export default BacklinkSourceNode;